import angular from 'angular'
import { LeadsPolicyEditorComponent } from './leads-policy-editor.component';
import { EditLeadStatusModal } from './edit-lead-status-modal.component';

export const LeadsPolicyModule = angular
    .module("apex.leads.policy", [])
    .component("apexLeadsPolicyEditor", LeadsPolicyEditorComponent)
    .component("apexEditLeadStatusModal", EditLeadStatusModal)
    .name
